@if (!isMobile()) {
  <div class="header-flex">
    <div class="header-left">
      <a [href]="homePageUrl() ? homePageUrl() : DEFAULT_HOMEPAGE_URL">
        <img
          ngSrc="assets/images/logo/piu_logo.png"
          width="120"
          height="46"
          priority
          alt="PIU logo"
        />
      </a>

      <div class="header-custom-divider"></div>
      <div class="header-title">
        Ministerstwo Rodziny, Pracy i Polityki Społecznej
      </div>
    </div>
    <div class="header-right">
      @if (user()) {
        @if (contextMenuItem.length > 1) {
          <div>
            <p-select
              [options]="contextMenuItem"
              [(ngModel)]="selectedOrganization"
              (onChange)="onChangeOrganization($event)"
              optionLabel="label"
              placeholder="Konto osobiste"
              appendTo="body"
              class="organization-select"
              inputId="organizationSelect"
              scrollHeight="500px"
              ariaLabel="Wybór organizacji"
              panelStyleClass="organization-select-panel"
              tooltipPosition="bottom"
              [tooltip]="selectedOrganization?.label ?? ''"
            >
              <ng-template pTemplate="selectedItem" let-item>
                <div class="truncate-3-lines">{{ item?.label }}</div>
              </ng-template>

              <ng-template pTemplate="item" let-item>
                <div>{{ item.label }}</div>
              </ng-template>
            </p-select>
          </div>
        } @else {
          <div
            class="headerIcon headerIcon-organization"
            ariaLabel="Konto osobiste"
          >
            Konto osobiste
          </div>
        }
        <div
          class="headerIcon headerIcon-session-time"
          ariaLabel="Pozostały czas sesji"
        >
          Czas sesji:
          {{
            sessionCounterService.remainingTime$ | async | date: 'mm:ss' : 'UTC'
          }}
          <p-button
            type="button"
            class="headerIcon headerIcon-session-time-action"
            (click)="authService.refreshSession()"
            ariaLabel="Przedłużanie sesji"
            pTooltip="Przedłuż sesję"
            tooltipPosition="bottom"
            [rounded]="true"
            [text]="true"
          >
            <span class="sr-only">Przedłuż sesję</span>
            <i class="pi pi-refresh" aria-hidden="true"></i>
          </p-button>
        </div>
        <div class="headerIcon headerIcon-settings cursor-pointer">
          <p-button
            type="button"
            class="headerIcon headerIcon-settings"
            (click)="navigateToSettings()"
            ariaLabel="Ustawienia"
            [pTooltip]="isCurrentContextAdmin() ? undefined : 'Ustawienia'"
            tooltipPosition="bottom"
            [rounded]="true"
            [text]="true"
            [disabled]="isCurrentContextAdmin()"
          >
            <span class="sr-only">Ustawienia</span>
            <i class="pi pi-cog" aria-hidden="true"></i>
          </p-button>
        </div>
        <div class="headerIcon headerIcon-logout cursor-pointer">
          <p-button
            type="button"
            class="headerIcon headerIcon-logout"
            (click)="logOut()"
            ariaLabel="Wyloguj"
            [rounded]="true"
            [text]="true"
          >
            <i class="pi pi-sign-out" aria-hidden="true"></i>
            <div class="flex flex-col">
              <div class="font-medium">Wyloguj</div>
              <div class="sign-out-user-name">
                {{ user()?.imie }}
              </div>
              <div class="sign-out-user-name">
                {{ user()?.nazwisko }}
              </div>
            </div>
          </p-button>
        </div>
      } @else if (isApplicationContextSelectView()) {
        <div class="headerIcon headerIcon-logout cursor-pointer">
          <p-button
            type="button"
            class="headerIcon headerIcon-logout"
            (click)="logOut()"
            ariaLabel="Wyloguj"
            [rounded]="true"
            [text]="true"
          >
            <i class="pi pi-sign-out" aria-hidden="true"></i> Wyloguj
          </p-button>
        </div>
      }
      <div class="eu-img-container">
        <img
          ngSrc="assets/images/logo/eu_logo.svg"
          alt="Logo Unii Europejskiej"
          width="80"
          height="49"
        />
      </div>
    </div>
  </div>
} @else if (isMobile()) {
  <div class="header-mobile">
    <div [class]="['header-mobile-left', firstLogin() && 'header-first-login']">
      @if (user() || firstLogin()) {
        <p-button
          type="button"
          class="sidebar-toggle-btn"
          ariaLabel="Otwórz/zamknij menu boczne"
          (click)="toogleSidebar.emit()"
          [rounded]="true"
          [text]="true"
        >
          <i
            [class]="[
              'pi',
              'pi-bars',
              sidebarVisible() ? 'sidebar-icon-rotated' : 'sidebar-icon-normal',
            ]"
            aria-hidden="true"
            style="font-size: 30px; color: black"
          ></i>
        </p-button>
      }
    </div>
    <div class="header-mobile-center">
      <div class="header-mobile-center-thumbnail">
        <a [href]="homePageUrl() ? homePageUrl() : DEFAULT_HOMEPAGE_URL">
          <img
            ngSrc="assets/images/logo/piu_logo.png"
            width="120"
            height="46"
            priority
            alt="PIU logo"
          />
        </a>
        <img
          ngSrc="assets/images/logo/eu_logo.svg"
          alt="Logo Unii Europejskiej"
          width="80"
          height="49"
        />
        @if (isApplicationContextSelectView()) {
          <div class="headerIcon headerIcon-logout cursor-pointer">
            <p-button
              type="button"
              class="headerIcon headerIcon-logout"
              (click)="logOut()"
              ariaLabel="Wyloguj"
              [rounded]="true"
              [text]="true"
            >
              <i class="pi pi-sign-out" aria-hidden="true"></i> Wyloguj
            </p-button>
          </div>
        }
      </div>
      @if (user()) {
        <div class="header-mobile-center-actions">
          @if (contextMenuItem.length > 1) {
            <div>
              <p-select
                [options]="contextMenuItem"
                [(ngModel)]="selectedOrganization"
                (onChange)="onChangeOrganization($event)"
                optionLabel="label"
                placeholder="Konto osobiste"
                appendTo="body"
                class="organization-select"
                inputId="organizationSelect"
                scrollHeight="500px"
                ariaLabel="Wybór organizacji"
                tooltipPosition="bottom"
                [tooltip]="selectedOrganization?.label ?? ''"
                panelStyleClass="organization-select-panel-mobile"
              >
                <ng-template pTemplate="selectedItem" let-item>
                  <div class="truncate-3-lines">{{ item?.label }}</div>
                </ng-template>

                <ng-template pTemplate="item" let-item>
                  <div>{{ item.label }}</div>
                </ng-template>
              </p-select>
            </div>
          } @else {
            <div
              class="headerIcon headerIcon-organization"
              ariaLabel="Konto osobiste"
            >
              Konto osobiste
            </div>
          }
          <div
            class="headerIcon headerIcon-session-time"
            ariaLabel="Pozostały czas sesji"
          >
            Czas sesji:
            {{
              sessionCounterService.remainingTime$
                | async
                | date: 'mm:ss' : 'UTC'
            }}
            <p-button
              type="button"
              class="headerIcon headerIcon-session-time-action"
              (click)="authService.refreshSession()"
              ariaLabel="Przedłuż sesje"
              [rounded]="true"
              [text]="true"
            >
              <span class="sr-only">Przedłuż sesję</span>
              <i class="pi pi-refresh" aria-hidden="true"></i>
            </p-button>
          </div>
        </div>
      }
    </div>
  </div>
}
